import Box from "@mui/material/Box";
import {
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useEffect, useState } from "react";
import React from "react";
import { PaymentHistoryHeader, paymentMethods } from "../../../utils/constants";
import LoadingSpinner from "../../common/Loading";
import ViewIcon from "../../IconComp/viewIcon";
import PdfIcon from "../../IconComp/pdfIcon";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import AllTable from "../../commontable/table";
import usePermissions from "../../../hooks/usePermissions";
import { SalesHistoryModal } from "../../salesHistory/salesHistoryModal";
import { ReturnInvoiceModal } from "../../return-item/return-invoice-model";
import { InvoiceModal } from "../invoice-model";
import { theme } from "../../../theme";
import {
  addCustomerPayment,
  changeReceive,
  getAllInvoices,
} from "../../../features/customerHistory/customerHistorySlice";
import { ColorPallet } from "../../../utils/colorPallet";
import { CustomerDetailsInvoice } from "../customerDetailsInvoice";

const textStyle = {
  color: {
    blackText: "#2C323D",
    blueText: "#0055A9",
    greenText: "#00BB8C",
  },
  fontSize: {
    small: "12px",
    medium: "14px",
    large: "16px",
    extraLarge: "26px",
  },
  fontWeight: {
    light: "300",
    regular: "400",
    semiBold: "500",
    medium: "600",
    bold: "700",
  },
  lineHeight: "100%",
  letterSpacing: "0px",
  fontFamily: theme.typography.fontFamily,
};

const CustomerPaymentHisModal = ({ customerId, setOpenSnackbar }: any) => {
  const pharmacyId = localStorage?.getItem("pharmacyId");

  useEffect(() => {
    if (pharmacyId && customerId) {
      getAllInvoiceses();
    }
  }, [pharmacyId, customerId]);

  const getAllInvoiceses = () => {
    dispatch(
      getAllInvoices({ pharmacy_id: pharmacyId, customer_id: customerId })
    );
  };
  const { allInvoices, isInvoiceLoading }: any = useAppSelector(
    (state) => state?.customer
  );
  const allInvoiceData = allInvoices[0]?.invoices;
  const totalAmount = allInvoiceData?.reduce(
    (accumulator: any, currentValue: any) =>
      accumulator + currentValue?.total_Amount,
    0
  );
  const paidAmount = allInvoiceData?.reduce(
    (accumulator: any, currentValue: any) =>
      accumulator + currentValue?.paid_amount,
    0
  );
  const dueAmount = allInvoiceData?.reduce(
    (accumulator: any, currentValue: any) =>
      accumulator + currentValue?.due_amount,
    0
  );

  // const dueAmount = totalAmount - paidAmount;
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );
  const dispatch = useAppDispatch();
  const isPermissions = usePermissions();
  const [selectedEnumValue, setSelectedEnumValue] = useState<any>("3");
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [isAppModalOpen, setIsAppModalOpen] = useState<boolean>(false);
  const [invoiceId, setInvoiceId] = useState<any>();
  const [sale, setSale] = useState<any>([]);
  const [isReturnModal, setIsReturnModal] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [openClearDuesInvoiceModal, setOpenClearDuesInvoiceModal] =
    useState(false);
  const [receiveNow, setReceiveNow] = useState("");
  const [receiveOnInvoice, setReceiveOnInvoice] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  let isPagination = true;
  const print = true;

  const handleRowClick = (rowData: any) => {
    setSelectedRow(rowData);
    setIsAppModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsAppModalOpen(false);
  };
  const handleSaveAndPrintInvoice = () => {
    handleCloseInvoiceModal(); // Close the modal
  };

  const handleOpenInvoiceModal = (
    invoiceNumber: any,
    sales: any,
    isReturn: any
  ) => {
    setInvoiceId(invoiceNumber);
    setSale(sales);
    setIsReturnModal(isReturn);
    setOpenInvoiceModal(true);
  };
  const handleCloseInvoiceModal = () => {
    setOpenInvoiceModal(false);
  };
  const handleOpenClearDuesInvoiceModal = (invoiceNumber: any) => {
    setInvoiceId(invoiceNumber);
    setOpenClearDuesInvoiceModal(true);
  };
  const handleCloseClearDuesInvoiceModal = () => {
    setOpenClearDuesInvoiceModal(false);
  };

  const handlePaymentSelect = (event: any) => {
    const selectedId = event.target.value;
    setSelectedEnumValue(selectedId);
  };

  const handleClearDues = async () => {
    if (Number(receiveNow) > dueAmount) {
      setErrorMessage("Receive amount cannot be greater than due amount");
      return;
    }
    const payment: any = {
      customer_id: customerId,
      pharmacy_id: pharmacyId,
      amount_paid: receiveNow,
      payment_type: selectedEnumValue,
      add_by_admin: true,
    };

    try {
      const res = await dispatch(addCustomerPayment(payment));
      if (res?.payload?.success === true) {
        setOpenSnackbar();
        getAllInvoiceses();
        handleOpenClearDuesInvoiceModal(allInvoiceData?.[0]?.id);
        setReceiveNow("");
        dispatch(changeReceive(true));
      }
    } catch (error) {
      console.error("Error adding Customer: ", error);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const isExpired = (expiryDate: string) => {
    return new Date(expiryDate) < new Date();
  };

  const filteredRow =
    allInvoiceData?.map((item: any) => ({
      "Invoice No.": item?.id || "-",
      Date: formatDate(item?.invoice_date) || "-",
      "Total Amt": item?.total_Amount?.toLocaleString("en-IN") || 0,
      "Dis(%)": item?.discount_percentage || 0,
      "Dis Amt": item?.discount_Amount?.toLocaleString("en-IN") || 0,
      "Total Payable":
        (item?.total_Amount - item?.discount_Amount)?.toLocaleString("en-IN") ||
        0,
      Paid: item?.paid_amount?.toLocaleString("en-IN") || 0,
      "Due(s)": item?.due_amount?.toLocaleString("en-IN") || 0,

      Actions: (
        <>
          {/* <DeleteIcon /> */}
          {(Account_Type === 0 ||
            (isPermissions?.edit && Account_Type === 1)) && (
            <Box sx={{ display: "flex", alignItems: "center", ml: -1 }}>
              <Tooltip title="View Details">
                <IconButton
                  aria-label="view"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRowClick(item);
                  }}
                >
                  <ViewIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print Invoice">
                <IconButton
                  aria-label="view"
                  sx={{ ml: -1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenInvoiceModal(
                      item["id"],
                      item["sales"],
                      item["is_return"]
                    );
                  }}
                >
                  <PdfIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </>
      ),
    })) || [];

  const totalAmount1 = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + item?.total_Amount,
    0
  );
  const totalDiscount = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + item?.discount_Amount,
    0
  );
  const totalPaid = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + item?.paid_amount,
    0
  );
  const totalRemaining = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + (item?.total_Amount - item?.paid_amount),
    0
  );
  const totalNetDue = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + (item?.total_Amount - item?.discount_Amount),
    0
  );
  const TotalDiscpercentage = allInvoiceData?.reduce(
    (sum: any, item: any) => sum + item?.discount_percentage,
    0
  );

  // 👇 Add total row to the list
  filteredRow.push({
    "Invoice No.": "Invoice(s)",
    Date: "Till Today",
    "Total Amt": totalAmount1?.toLocaleString("en-IN") || 0,
    "Dis(%)": TotalDiscpercentage || 0,
    "Dis Amt": totalDiscount?.toLocaleString("en-IN") || 0,
    "Total Payable": totalNetDue?.toLocaleString("en-IN") || 0,
    Paid: totalPaid?.toLocaleString("en-IN") || 0,
    "Due(s)": dueAmount?.toLocaleString("en-IN") || 0,
    Actions: "-",
  });
  const hasAccess =
    Account_Type === 0 || (isPermissions?.view && Account_Type === 1);
  const filteredRowData = hasAccess ? filteredRow : [];

  return (
    <>
      {/** Payment History Table */}
      {isInvoiceLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "20vh", // Set height to full viewport height
          }}
        >
          <LoadingSpinner />
        </Box>
      ) : (
        <Box>
          <AllTable
            headerData={PaymentHistoryHeader}
            rowData={filteredRowData}
            isPagination={true}
            payHistory={true}
          />
        </Box>
      )}

      {/** Payment History other details */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 2,
        }}
      >
        <Box>
          <Typography
            sx={{
              ...textStyle,
              color: textStyle.color.blackText,
              fontSize: textStyle.fontSize.medium,
              fontWeight: textStyle.fontWeight.regular,
            }}
          >
            Total:{" "}
            <span
              style={{
                fontWeight: textStyle.fontWeight.medium,
                fontSize: textStyle.fontSize.large,
              }}
            >
              Rs {totalAmount?.toLocaleString("en-IN")}
            </span>{" "}
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: textStyle.color.blackText,
              fontSize: textStyle.fontSize.medium,
              fontWeight: textStyle.fontWeight.regular,
              mt: 1,
            }}
          >
            Received:{" "}
            <span
              style={{
                fontWeight: textStyle.fontWeight.medium,
                fontSize: textStyle.fontSize.large,
              }}
            >
              Rs {paidAmount?.toLocaleString("en-IN")}
            </span>{" "}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              ...textStyle,
              color: textStyle.color.blackText,
              fontSize: textStyle.fontSize.medium,
              fontWeight: textStyle.fontWeight.semiBold,
            }}
          >
            Due Payment
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: textStyle.color.blueText,
              fontSize: textStyle.fontSize.extraLarge,
              fontWeight: textStyle.fontWeight.medium,
            }}
          >
            Rs. {dueAmount?.toLocaleString("en-IN")}
          </Typography>
          <Typography
            sx={{
              ...textStyle,
              color: textStyle.color.blackText,
              fontSize: textStyle.fontSize.large,
              fontWeight: textStyle.fontWeight.semiBold,
            }}
          >
            Paid Amount:{" "}
            <span
              style={{
                color: textStyle.color.greenText,
                fontSize: textStyle.fontSize.large,
                fontWeight: textStyle.fontWeight.medium,
              }}
            >
              Rs {paidAmount?.toLocaleString("en-IN")}
            </span>{" "}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "flex-end",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <Typography
                sx={{
                  ...textStyle,
                  color: textStyle.color.blackText,
                  fontSize: textStyle.fontSize.large,
                  fontWeight: textStyle.fontWeight.semiBold,
                }}
              >
                Receive Now:
              </Typography>
              <TextField
                variant="outlined"
                label="Payment"
                size="small"
                type="number"
                sx={{
                  width: "130px",
                  height: "37px",
                  "& label": {
                    color: "#D9D9D9",
                  },
                  "& label.Mui-focused": {
                    color: "#D9D9D9",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#D9D9D9",
                    },
                    "&:hover fieldset": {
                      borderColor: "#D9D9D9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#D9D9D9",
                    },
                  },
                }}
                value={receiveNow}
                onChange={(e) => {
                  setReceiveNow(e.target.value);
                  setReceiveOnInvoice(e.target.value);
                  setErrorMessage("");
                }}
                error={Boolean(errorMessage)}
              />
            </Box>
            {errorMessage && (
              <Typography
                variant="caption"
                sx={{
                  color: "#d32f2f", // same as MUI error color
                  fontSize: "0.75rem",
                  marginLeft: "8px", // aligns with TextField's padding
                  textAlign: "right",
                  width: "400px",
                }}
              >
                {errorMessage}
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              mt: 0.5,
            }}
          >
            <Typography
              sx={{
                display: "flex",
                justifyContent: "end",
                ...textStyle,
                color: textStyle.color.blackText,
                fontSize: textStyle.fontSize.large,
                fontWeight: textStyle.fontWeight.semiBold,
              }}
            >
              Select Payment Method
            </Typography>
            <Box
              sx={{
                my: 1,
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={selectedEnumValue}
                onChange={handlePaymentSelect}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "4px", // control spacing between each
                  alignItems: "center",
                }}
              >
                {paymentMethods.map((method) => (
                  <FormControlLabel
                    key={method.id}
                    value={method.id}
                    control={
                      <Radio
                        sx={{
                          p: 0.5,
                          transform: "scale(0.7)",
                        }}
                      />
                    }
                    label={
                      <Tooltip title={method.value} arrow placement="top">
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            m: 0,
                            p: 0,
                          }}
                        >
                          {method.icon}
                        </Box>
                      </Tooltip>
                    }
                    sx={{ m: 0, p: 0 }}
                  />
                ))}
              </RadioGroup>
            </Box>
          </Box>
          <Tooltip
            title={
              !receiveNow
                ? "Please enter an amount in 'Receive Now' to proceed."
                : ""
            }
            disableHoverListener={!!receiveNow} // Enable tooltip only when disabled
          >
            <span>
              <AppButton
                variant="contained"
                color="primary"
                onClick={handleClearDues}
                title="Clear Dues"
                sx={{
                  textTransform: "none",
                }}
                disabled={!receiveNow}
              />
            </span>
          </Tooltip>

        </Box>
      </Box>

      {/** Payment View History */}

      <AppModal
        title="Sales History Details"
        open={isAppModalOpen}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="lg"
      >
        {isAppModalOpen && selectedRow && (
          <SalesHistoryModal
            invoiceId={selectedRow["id"]}
            isPagination={isPagination}
          />
        )}

        <Box sx={{ py: 6 }}>
          <AppButton
            variant="contained"
            type="submit"
            title="Close"
            sx={{
              float: "right",
              backgroundColor: "#F9F9F9",
              color: "#000000",
              fontSize: "16px",
              fontWeight: "400",
              "&:hover": {
                backgroundColor: "#DDDDDD",
                color: "#000000",
              },
            }}
            onClick={handleCloseModal}
          />
        </Box>
      </AppModal>

      <AppModal
        title="Invoice Details"
        open={openInvoiceModal}
        handleClose={handleCloseInvoiceModal}
        fullScreen={false}
        maxWidth="sm"
        //maxWidth="md"
        // maxWidth={"10%"}
      >
        {isReturnModal ? (
          <ReturnInvoiceModal
            onClose={handleCloseInvoiceModal}
            invoiceId={invoiceId}
            //purchasedItem={purchasedItem}
            returnItem={sale}
            isPrint={print}
            handleSubmit={handleSaveAndPrintInvoice}
            // discountedAmount={discountedAmount}
          />
        ) : (
          <InvoiceModal
            invoiceId={invoiceId}
            onClose={handleCloseInvoiceModal}
            onSaveAndClose={handleSaveAndPrintInvoice}
            isPrint={print}
          />
        )}
      </AppModal>
      <AppModal
        title="Invoice Details"
        open={openClearDuesInvoiceModal}
        handleClose={handleCloseClearDuesInvoiceModal}
        fullScreen={false}
        maxWidth="sm"
        //maxWidth="md"
        // maxWidth={"10%"}
      >
        <CustomerDetailsInvoice
          invoiceId={invoiceId}
          allInvoices={allInvoices}
          //selectedInstructions={selectedInstructions}
          onClose={handleCloseClearDuesInvoiceModal}
          onSaveAndClose={handleSaveAndPrintInvoice}
          paidAmount={paidAmount}
          dueAmount={dueAmount}
          receiveOnInvoice={receiveOnInvoice}
          // handleCloseEditFunction={handleCloseEditFunction}
        />
      </AppModal>
    </>
  );
};

export default CustomerPaymentHisModal;
